import React, { useState } from 'react';

const UtilityItem = ({ label }) => {
  return (
    <div className="utility-item">
      <p>{label}</p>
    </div>
  );
};

export default UtilityItem;